import React, { useState } from 'react'
import Slider from './Slider'
import { useDispatch } from 'react-redux'
import UserRightsTable from './UserRightsTable'
import * as components from '../../components'
import * as rest from '../../services'
import { showErrorToast } from '../../state/toasts'

const UserRightsSlider = ({ user, buttonType }) => {
  const dispatch = useDispatch()
  const [loading, setLoading] = useState(false)
  const [isPaneOpen, setIsPaneOpen] = useState(false)
  const [rights, setRights] = useState([])
  const loadRights = () => {
    setLoading(true)
    new rest.UserService(user.url)
      .getUserRights()
      .then((response) => {
        setRights(response.results)
        setLoading(false)
      })
      .catch((errors) => {
        setLoading(false)
        dispatch(
          showErrorToast('Could not read user rights', errors.response.data)
        )
      })
  }

  return (
    <>
      <Slider
        title="User Rights"
        overlayClassName="on-top"
        buttonType={buttonType}
        onAfterOpen={loadRights}
        isOpen={isPaneOpen}
        onRequestClose={() => {
          setIsPaneOpen(false)
        }}
      >
        {loading || !rights ? (
          <components.Loading />
        ) : (
          <UserRightsTable user={user} rights={rights} onChange={loadRights} />
        )}
      </Slider>
    </>
  )
}

export default UserRightsSlider
